export const formatPhone = (phone: string): string => {
  if (!phone) {
    return
  }
  return String(phone).replaceAll(' ', '').trim()
}
